import { Typography, TypographyProps } from "@mui/material"
import usePrivacyPolicyLink from "hooks/usePrivacyPolicyLink"
import styled from "styled-components"

const StyledPrivacyPolicyCaption = styled((props: TypographyProps) => (
  <Typography variant="body2" {...props} />
))`
  align-self: flex-start;
  margin: 22px 0;
`

const StyledLink = styled.a`
  text-decoration: underline !important;
`

const PrivacyPolicyCaption = ({ style }: { style?: React.CSSProperties }) => {
  const privacyPolicyLink = usePrivacyPolicyLink()
  return (
    <StyledPrivacyPolicyCaption style={style}>
      מסירת הפרטים מהווה הסכמה{" "}
      <StyledLink href={privacyPolicyLink} target="_blank">
        למדיניות הפרטיות
      </StyledLink>{" "}
      של דלק מוטורס
    </StyledPrivacyPolicyCaption>
  )
}

export default PrivacyPolicyCaption
